export const MAX_BAR_THICKNESS = 29;

/** Drop inner gutters on tile mini bars once the option count exceeds this. */
export const PACK_INNER_GAPS_AFTER = 5;

// One bar: fill the track, or center a capped bar. Several bars: space-evenly
// (gaps on both edges and between) so a 2-option run tally is not packed
// against the sides. Each gap is at least 1px when the bars have to shrink.
// `packInnerGaps` keeps those edge gutters but lets bars abut so a crowded
// tile still shows every option as a curve.
export function layoutBars(
  trackSize,
  count,
  maxThickness = MAX_BAR_THICKNESS,
  options = {}
) {
  const n = Math.max(1, count);

  if (n === 1) {
    const thickness =
      maxThickness == null
        ? trackSize
        : Math.min(maxThickness, Math.max(0, trackSize));
    const leftover = Math.max(0, trackSize - thickness);
    return { thickness, gap: leftover, offsets: [leftover / 2] };
  }

  if (options.packInnerGaps) {
    const minEdge = 1;
    const fitted = Math.max(0, (trackSize - 2 * minEdge) / n);
    const thickness =
      maxThickness == null ? fitted : Math.min(maxThickness, fitted);
    const leftover = Math.max(0, trackSize - n * thickness);
    const edge = leftover / 2;
    const offsets = [];
    for (let i = 0; i < n; i += 1) {
      offsets.push(edge + i * thickness);
    }
    return { thickness, gap: 0, offsets };
  }

  const gapSlots = n + 1;
  const fitted = Math.max(0, (trackSize - gapSlots) / n);
  const thickness =
    maxThickness == null ? fitted : Math.min(maxThickness, fitted);
  const leftover = Math.max(0, trackSize - n * thickness);
  const gap = leftover / gapSlots;

  const offsets = [];
  for (let i = 0; i < n; i += 1) {
    offsets.push(gap + i * (thickness + gap));
  }

  return { thickness, gap, offsets };
}
